var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"fluid":false}},[_c('page-header',{attrs:{"title":_vm.motivo.nombre,"subtitle":"Motivo de cierre","back-to":"/motivosCierreOferta"}}),_c('formulario-motivo',{attrs:{"motivo":_vm.motivo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }